//** @jsxImportSource @emotion/react */
import React, { FC } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { FormGroup, Label, FormFeedback } from 'reactstrap'

import { Select } from 'library'
import { getClients, fetchClients } from 'store/invoices/clients'

const InvoiceClientSelect: FC<any> = ({
  field,
  form: { touched, errors, setFieldValue },
  label,
  ...props
}) => {
  const dispatch = useDispatch()
  const { clients, loading } = useSelector(getClients)

  React.useEffect(() => {
    if (!clients && !loading) dispatch(fetchClients.request())
  }, [clients, dispatch, loading])

  const options = React.useMemo(
    () =>
      !clients
        ? []
        : Object.values(clients).map((p: any) => ({
            value: p.id,
            label: p.label,
          })),
    [clients]
  )

  return (
    <FormGroup css={{ display: 'flex', alignItems: 'center', marginBottom: 0 }}>
      <Label for={props.name} css={{ width: 130, marginBottom: 0 }}>
        {label}
      </Label>

      <Select
        {...field}
        {...props}
        value={options.filter((option) => option.value === field.value)}
        options={options}
        isLoading={loading}
        onChange={(option: any) => {
          setFieldValue(field.name, option.value)
        }}
        width={170}
        fontSize={12}
        inputId={field.name}
        invalid={!!errors[field.name]}
        placeholder=""
      />

      {touched[field.name] && errors[field.name] && (
        <FormFeedback
          css={{ width: 90, margin: '0 0 0 10px', display: 'block' }}
        >
          {errors[field.name]}
        </FormFeedback>
      )}
    </FormGroup>
  )
}

export default InvoiceClientSelect
